import React from 'react';
import root from 'window-or-global';
import Message from '../../components/message/Message';

/**
 * 404 component.  Shown when page not found.
 *
 */
const Error404 = function Error404(props) {
    return (
        <div className="error-page error-404">
            <div className="description-content">
                <h2>
                    <Message code="epic.battlebreakers.error.404" />
                </h2>
                <div className="back-home">
                    <a href={root.appContext}>
                        <span className="home-btn">
                            <Message code="epic.battlebreakers.homepage" />
                        </span>
                    </a>

                </div>
            </div>
        </div>
    );
};

export default Error404;
